<template>
  <el-dialog :visible.sync="newouterVisible" append-to-body>
    <img :src="img_status" />
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      newouterVisible: false,
      img_status:""
    };
  },
  methods: {
    init(a) {
      this.img_status = a
      this.newouterVisible = true;
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/.el-dialog {
  width: 800px;
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding: 0;
  }
  img {
    width: 800px;
    margin:0 auto
    
  }
}
</style>